module.exports = __webpack_public_path__ + "static/media/e-mobality.f0263a61.png";